import { trackEvent } from '@finn-no/pulse-sdk';

// Pulse tracker id: TR_ev17 and TR_ev18 (see tracking section in README.md)
export const trackCreateOrRepublishAdButton = (platform: string, itemId: string | undefined, primary: boolean) => {
    trackEvent({
        type: 'Click',
        intent: 'Create',
        object: {
            id: itemId ? `republish_ad_${platform}` : `new_ad_${platform}`,
            contentId: itemId ?? null,
            type: 'UIElement',
            position: primary ? 'primary' : 'secondary',
            elementType: 'Button',
        },
        target: {
            id: `${itemId ? 'republish' : 'create'}_ad_${platform}`,
            type: platform === 'finn' ? 'ClassifiedAd' : 'ExternalContent',
            name: `${itemId ? 'Republish' : 'Create'} ad on ${platform}`,
            category: `realestate > realestate-letting${platform !== 'finn' ? '-external' : ''}`,
        },
        vertical: {
            name: 'realestate',
            subVertical: 'lettings',
        },
    });
};

// Pulse tracker id: TR_ev20 (see tracking section in README.md)
export const trackGoToExpiredAds = () => {
    trackEvent({
        type: 'Click',
        intent: 'View',
        name: 'Go to expired letting ads on FINN',
        object: {
            id: 'landing_page_go_to_expired_letting_ads',
            type: 'UIElement',
            elementType: 'Link',
        },
        target: {
            id: 'listing_letting_expired_ads_finn',
            type: 'Listing',
            name: 'Go to expired letting ads on FINN',
        },
        vertical: {
            name: 'realestate',
            subVertical: 'lettings',
        },
    });
};

// Pulse tracker id: TR_ev19 (see tracking section in README.md)
export const trackGoToQasaLandingPageFromPlatformSelector = () => {
    trackEvent({
        type: 'Click',
        intent: 'View',
        name: 'Go to Qasa landing page from platform_selector',
        object: {
            id: 'qasa_landing_page_link_from_platform_selector',
            type: 'UIElement',
            elementType: 'Link',
        },
        target: {
            id: 'qasa_landing_page',
            type: 'Article',
            name: 'Landing page about Qasa',
        },
        vertical: {
            name: 'realestate',
            subVertical: 'lettings',
        },
    });
};

// Pulse tracker id: TBD (see tracking section in README.md)
export const trackBenefitDropdownExpand = (platform: 'finn' | 'qasa', itemId: string | null, buttonTitle: string) => {
    trackEvent({
        type: 'Click',
        intent: 'Show',
        name: `Expand benefit dropdown on ${platform}`,
        object: {
            id: `benefit_dropdown_${platform}_${buttonTitle.toLowerCase().replace(/\s+/g, '_')}`,
            contentId: itemId,
            type: 'UIElement',
            elementType: 'Expandable',
        },
        target: {
            id: `benefit_details_${platform}`,
            type: 'UIElement',
            name: buttonTitle,
        },
        vertical: {
            name: 'realestate',
            subVertical: 'lettings',
        },
    });
};
